import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import cx from 'classnames';
import style from './spinner.scss';

@CSSModules(style, { allowMultiple: true })
export default class Spinner extends Component {
  static defaultProps = {
    height: ''
  };

  render() {
    const styleNames = cx({
      root: true,
      block: this.props.block,
      center: this.props.center,
      fullPage: this.props.fullPage,
      muhimma: process.muhimma.indexOf(process.target[0]) !== -1
    });

    const style = {
      height: this.props.height
    };

    return (
      <span styleName={styleNames} style={{...style, ...this.props.style}}>
        <span styleName="wrapper">
          <span styleName="spinner" />
        </span>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/spinner.js